export const formStructure = [
  [
    {
      name: 'numeroNF',
      label: 'Numero NF',
      placeholder: 'Digite o numero da NF',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 },
      required: true,
      maxLength: 45,
      validation: {
        required: 'Numero NF e obrigatorio'
      }
    },
    {
      name: 'cnpjCliente',
      label: 'CNPJ Cliente',
      placeholder: 'Digite o CNPJ do cliente',
      component: 'MaskedInput',
      type: 'text',
      colProps: { md: 4 },
      maxLength: 18,
      mask: [
        /[0-9]/,
        /[0-9]/,
        '.',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '.',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '/',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '-',
        /[0-9]/,
        /[0-9]/
      ],
      guide: false,
      required: true,
      validation: {
        required: 'CNPJ e obrigatorio'
      }
    },
    {
      name: 'tipoOperacao',
      label: 'Tipo Operacao',
      placeholder: 'Digite o tipo de operacao',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 },
      maxLength: 255
    }
  ],
  [
    {
      name: 'nomeDestinatario',
      label: 'Nome Destinatario',
      placeholder: 'Digite o destinatario',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 },
      maxLength: 255
    },
    {
      name: 'nomeRemetente',
      label: 'Nome Remetente',
      placeholder: 'Digite o remetente',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 },
      maxLength: 255
    }
  ],
  [
    {
      name: 'dataChegada',
      label: 'Data Chegada',
      placeholder: 'Selecione a data de chegada',
      component: 'DatePickers',
      type: 'date',
      colProps: { md: 3 }
    },
    {
      name: 'quantidadeTotalCaixas',
      label: 'Qtde Caixas',
      placeholder: 'Digite a quantidade de caixas',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    },
    {
      name: 'quantidadeTotalPaletes',
      label: 'Qtde Paletes',
      placeholder: 'Digite a quantidade de paletes',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    },
    {
      name: 'quantidadeTotalEtiquetas',
      label: 'Qtde Etiquetas',
      placeholder: 'Digite a quantidade de etiquetas',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    }
  ],
  [
    {
      name: 'idDepositoTabelaPreco',
      label: 'Tabela Preco',
      placeholder: 'Selecione a tabela de preco',
      component: 'SelectWithModal',
      colProps: { md: 3 }
    },
    {
      name: 'valorUnPallet',
      label: 'Valor Pallet',
      placeholder: 'Digite o valor unitario',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    },
    {
      name: 'valorUnEtiqueta',
      label: 'Valor Etiqueta',
      placeholder: 'Digite o valor unitario',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    },
    {
      name: 'valorUnArmazenagemPallet',
      label: 'Valor Arm. Pallet',
      placeholder: 'Digite o valor unitario',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    }
  ],
  [
    {
      name: 'freetime',
      label: 'Freetime',
      placeholder: 'Dias de freetime',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    }
  ],
  [
    {
      name: 'observacoes',
      label: 'Observacoes',
      placeholder: 'Digite observacoes',
      component: 'Textarea',
      type: 'textarea',
      colProps: { md: 12 },
      rows: 4
    }
  ]
];

export const formSections = () => [
  { title: 'Identificacao', rows: [0] },
  { title: 'Dados das Partes', rows: [1] },
  { title: 'Datas e Quantidades', rows: [2] },
  { title: 'Tabela e Valores', rows: [3, 4] },
  { title: 'Observacoes', rows: [5] }
];

export const validateForm = (values) => {
  const errors = {};

  if (!values.numeroNF || values.numeroNF.trim().length === 0) {
    errors.numeroNF = 'Numero NF e obrigatorio';
  }

  if (!values.cnpjCliente || values.cnpjCliente.trim().length === 0) {
    errors.cnpjCliente = 'CNPJ e obrigatorio';
  }

  return errors;
};
